// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__ddXje","header":"Messages_header__kcgy1"};